<template>
    <loading v-if="isLoading" />

    <transition v-else name="fade">
        <section class="channel">
            <board />
            <filters v-if="isMobile === false"></filters>
            <create-job v-if="columns.length > 0" />
        </section>
    </transition>
</template>

<script>
/* global Echo, app */
import { mapState } from 'vuex'
import Board from './Board'
import Filters from './Filters'
import CreateJob from './CreateJob'
import Loading from '../Global/Loading'
import Device from '../../mixins/deviceAware'

export default {
    mixins: [Device],

    props: {
        channelId: {
            type: Number,
            required: true
        }
    },

    data () {
        return {
            isLoading: true
        }
    },

    created () {
        Promise.all([
            this.$store.dispatch('channel/fetchChannel', this.channelId),
            this.$store.dispatch('channel/fetchJobs', this.channelId)
        ]).then(() => {
            this.isLoading = false
            this.$store.dispatch('channel/fetchMembers', this.channelId)
            this.$store.dispatch('channel/fetchLabels', this.channelId)
            this.$store.dispatch('tenant/fetchUsers')
        }).finally(() => {
            Echo.private(`${app.currentTenant.id}_channel_${this.channelId}`)
                .listen('ChannelWasUpdated', (e) => {
                    this.$store.commit('channel/SET_CHANNEL', (e.channel))
                })
                .listen('ColumnWasCreated', (e) => {
                    this.$store.commit('channel/ADD_COLUMN', (e.column))
                })
                .listen('ColumnWasUpdated', (e) => {
                    this.$store.commit('channel/SET_COLUMN', (e.column))
                })
                .listen('ColumnWasDeleted', (e) => {
                    this.$store.commit('channel/REMOVE_COLUMN', (e.column_id))
                })
                .listen('ColumnWasRepositioned', (e) => {
                    this.$store.commit('channel/REPOSITION_COLUMN', e.column)
                })
                .listen('JobWasUpdated', (e) => {
                    this.$store.commit('channel/SET_JOB', (e.job))
                })
                .listen('JobDueDateWasChanged', (e) => {
                    this.$store.commit('channel/SET_JOB', (e.job))
                    this.$store.commit('channel/REMOVE_COLUMN', (e.column_id))
                })
                .listen('JobWasCreated', (e) => {
                    this.$store.commit('channel/ADD_JOB', (e.job))
                    this.$store.dispatch('channel/fetchJobMembers', (e.job))
                })
                .listen('JobWasRepositioned', (e) => {
                    this.$store.commit('channel/SET_JOB', (e.job))
                })
                .listen('JobWasMoved', (e) => {
                    this.$store.commit('channel/SET_JOB', (e.job))
                })
                .listen('JobWasRenamed', (e) => {
                    this.$store.commit('channel/SET_JOB', (e.job))
                })
                .listen('JobWasReinstated', (e) => {
                    this.$store.commit('channel/ADD_JOB', (e.job))
                    this.$store.commit('channel/REMOVE_ARCHIVED_JOB', (e.job.id))
                })
                .listen('JobMemberWasRemoved', (e) => {
                    this.$store.commit('channel/REMOVE_JOB_MEMBER', (e))
                })
                .listen('JobWasArchived', (e) => {
                    this.$store.commit('channel/REMOVE_JOB', (e.job.id))
                    this.$store.commit('channel/ADD_ARCHIVED_JOB', (e.job))
                })
                .listen('JobMemberWasAdded', (e) => {
                    this.$store.commit('channel/ADD_JOB_MEMBER', (e.member))
                })
                .listen('CommentWasCreated', (e) => {
                    this.$store.commit('channel/SET_JOB_ACTIVITY', (e.comment))
                })
                .listen('ColumnJobsWereArchived', (e) => {
                    this.$store.commit('channel/REMOVE_COLUMN_JOBS', (e.column_id))
                })
                .listen('UserWasInvitedToChannel', (e) => {
                    this.$store.commit('channel/ADD_MEMBER', (e.user))
                })
                .listen('ChannelMemberWasRemoved', (e) => {
                    this.$store.commit('channel/REMOVE_MEMBER', (e.user_id))
                })
                .listen('LabelWasCreated', (e) => {
                    this.$store.commit('channel/ADD_LABEL', (e.label))
                })
                .listen('LabelWasUpdated', (e) => {
                    this.$store.commit('channel/SET_LABEL', (e.label))
                })
                .listen('LabelWasDeleted', (e) => {
                    this.$store.commit('channel/REMOVE_LABEL', (e.label_id))
                })
                .listen('LabelWasAdded', (e) => {
                    this.$store.commit('channel/ADD_JOB_LABEL', (e))
                })
                .listen('LabelWasRemoved', (e) => {
                    this.$store.commit('channel/REMOVE_JOB_LABEL', (e))
                })
        })
    },

    computed: {
        ...mapState('channel', ['channel', 'columns'])
    },

    components: {
        Board,
        Filters,
        CreateJob,
        Loading
    }
}
</script>
